"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._isSupportedContentType = void 0;
const content_type_1 = __importDefault(require("content-type"));
const constants_1 = require("./constants");
const _isSupportedContentType = (contentType) => {
    var _a, _b;
    const parsedContentType = content_type_1.default.parse(contentType);
    const contentTypeIsValid = Object.values(constants_1.supportedContentTypes).some(contentTypes => contentTypes.includes(parsedContentType.type));
    const processors = (((_a = parsedContentType.parameters) === null || _a === void 0 ? void 0 : _a.processors) || '')
        .split(',')
        .map((p) => p.toLowerCase().trim())
        .filter((p) => p !== '');
    const processorsAreValid = processors.every(p => constants_1.supportedProcessors.includes(p));
    const postProcessors = (((_b = parsedContentType.parameters) === null || _b === void 0 ? void 0 : _b.postprocessors) || '')
        .split(',')
        .map((pp) => pp.toLowerCase().trim())
        .filter((pp) => pp !== '');
    const postProcessorsAreValid = postProcessors.every(pp => constants_1.supportedPostProcessors.includes(pp));
    return contentTypeIsValid && processorsAreValid && postProcessorsAreValid;
};
exports._isSupportedContentType = _isSupportedContentType;
